import $ from 'jquery';
import _ from 'underscore';
import queryString from 'query-string';
import Uri from 'urijs';

export const projectionGridScopeNavigator = definePlugin => definePlugin('projectionGridScopeNavigator', [
  'config',
  'gridView',
], ({
  plugins: {
    projectionGridScopeNavigator: scope,
  },
} = {}, gridView) => {
  function navigate(e) {
    const $target = $(e.target);
    const targetCid = $target.data('cid');
    const targetAid = $target.data('aid');
    const campaignId = $target.data('campaignid');
    const adGroupId = $target.data('adgroupid');
    const customParams = $target.data('customparams');
    let pathname = $target.data('pathname');
    const skipScopeNavigation = $target.data('skipscopenavigation');
    const preventDefaultNavigation = $target.data('preventdefaultnavigation');
    const { cid, aid, uid } = scope.values;

    if (!pathname) {
      const href = $target.attr('href');
      if (!_.isUndefined(href)) {
        const uri = new Uri(href);
        uri.normalizeProtocol();
        if (uri.protocol() !== 'javascript') { // prevent invaid pathname for javascript href
          pathname = uri.pathname();
        }
      }
    }

    if (skipScopeNavigation) {
      return true;
    }

    if (preventDefaultNavigation) {
      e.preventDefault();
    }

    if (!_.isUndefined(targetCid)) {
      scope.set({
        cid: targetCid, uid,
      });
    }

    if (!_.isUndefined(targetAid)) {
      scope.set({
        cid: targetCid || cid, aid: targetAid, uid,
      });
    }

    if (!_.isUndefined(campaignId)) {
      scope.set({
        cid, aid, uid, campaignId,
      });
    }

    if (!_.isUndefined(adGroupId)) {
      scope.set({
        cid, aid, uid, campaignId, adGroupId,
      });
    }

    if (!_.isUndefined(customParams)) {
      const customQueries = queryString.parse(customParams);
      scope.set(_.extend({
        cid, aid, uid,
      }, customQueries));
    }

    if (!_.isUndefined(pathname)) {
      scope.save(pathname);
    } else {
      scope.save();
    }

    return false;
  }

  const scopeNavigatorProjection = {
    name: 'scopeNavigatorProjection',
    handler: function scopeNavigator(state) {
      const events = _.defaults({
        'click .scope-navigator': navigate,
      }, state.events);

      return _.defaults({ events }, state);
    },
  };

  gridView.pipeContentProjections(scopeNavigatorProjection);
});
